import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 52px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

export const Aside = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 52px);
  width: 72px;
  background-color: ${({ theme }) => theme.palette.branding.main};
`;

export const Main = styled(Box)`
  background-color: ${({ theme }) => theme.palette.primary.main};
`;
